import React from "react";

const BS5_GridBasic = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_GridBasic Component</h2>
      <p>This is the BS5_GridBasic component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_GridBasic;
